/**
 * decimalString - round a number to a maximum number of whole and decimal places avoiding floating point errors
 */
export const decimalString = (number, maxWhole, maxDecimals) => {
    number = String(number)
    let parts = number.match(/^([+-]?)(\d*)(\.?)(\d*)$/) // allow negative numbers and decimals
    if (!parts || !number.length) return ''
    let [_, sign, whole, point, decimal] = parts
    if (sign === '+') sign = ''
    if (!whole.length && !decimal.length) return ''
    whole = whole.replace(/^0+/, '').padStart(1, '0') // remove leading zeros and pad with a 0 if there's no whole number
    decimal = decimal.replace(/0+$/, '') // remove trailing zeros
    // round to maxDecimals avoiding floating point errors
    if (decimal.length > maxDecimals) {
        decimal = (parseInt(decimal.substring(0, maxDecimals) || '0', 10) + (decimal[maxDecimals] >= 5 ? 1 : 0)).toString().padStart(maxDecimals, '0')
        if (decimal.length > maxDecimals && !(maxDecimals === 0 && decimal === '0')) { // if the decimal is still too long, increment the whole number
            whole = (BigInt(whole) + BigInt(1)).toString()
            decimal = ''
        }
        decimal = decimal.replace(/0+$/, '') // remove trailing zeros
    }
    if (whole.length > maxWhole && !(maxWhole === 0 && whole === '0')) {
        return ''
    }
    if (whole === '0' && decimal === '') {
        sign = ''
    }
    return (sign + whole + point + decimal.substring(0, maxDecimals)).replace(/(\.0*|(\.[0-9]*?)0+)$/, '$2')
}